/* eslint-disable react/prop-types */
import React from 'react';
import { Video as OriginalVideo } from '@fiverr-private/media';
import { withToggleButton } from './helpers/withToggleButton';

const Video = ({ source, sources, showToggleButton, ...restProps }) => {
    const VideoComponent = showToggleButton ? withToggleButton(OriginalVideo) : OriginalVideo;

    return <VideoComponent sources={sources || source} {...restProps} />;
};

Video.displayName = 'Video';
export default Video;
